var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketStateCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36963",
    "data-name": "Path 36963",
    d: "M0,0H24V24H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36964",
    "data-name": "Path 36964",
    d: "M11.816,1.318a10.5,10.5,0,1,1-10.5,10.5,10.5,10.5,0,0,1,10.5-10.5ZM9.636,15.228,7.065,12.656a1.125,1.125,0,0,1,1.591-1.591l1.812,1.814L14.977,8.37a1.125,1.125,0,1,1,1.591,1.591l-5.305,5.305a1.128,1.128,0,0,1-1.591,0l-.036-.038Z",
    transform: "translate(0.188 0.188)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStateCheckCircle);
export default __webpack_public_path__ + "static/media/ticket-state-check-circle.1fbab50f4b5ae44dc9315759944b6a35.svg";
export { ForwardRef as ReactComponent };